import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading, withRouterConfig, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { PDFJS_LICENSE_TOKEN, provideSeedDesignSystem } from '@aionzdev/design-system';
import {
  geoLocationInterceptor,
  provideGeoLocation,
  provideInterceptors,
  WebSocketModule
} from '@aionzdev/modules';

import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { routes } from './app.routes';
import { httpCacheInterceptor } from './core/interceptors/http-cache.interceptor';
import { AionzTranslateLoader } from './core/loaders/aionz-translate-loader';
import { provideCacheInvalidation } from './core/providers/cache.providers';
import { provideModulesConfig } from './core/providers/modules.providers';
import { provideCoreServices } from './core/providers/services.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: PDFJS_LICENSE_TOKEN, useValue: 'EdFyE4N4uwLN2pix8FNK' },
    provideCoreServices(),
    provideModulesConfig(),
    provideInterceptors(),
    provideTranslateService({
      loader: provideTranslateLoader(AionzTranslateLoader),
      lang: 'pt-BR',
      fallbackLang: 'pt-BR',
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes,
      withComponentInputBinding(),
      withViewTransitions(),
      withPreloading(PreloadAllModules),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(
      withInterceptors([geoLocationInterceptor, httpCacheInterceptor]),
      withInterceptorsFromDi(),
      withFetch()
    ),
    provideCacheInvalidation(),
    provideClientHydration(withEventReplay()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideNgxMask(),
    provideSeedDesignSystem(),
    provideGeoLocation(),
    importProvidersFrom(WebSocketModule),

  ],
};
